module.exports = __webpack_public_path__ + "img/tt.0b68f6ff.svg";